import React from "react";
import { useDispatch } from "react-redux";
import { removeErrorNotification } from "store/errors/slice";
import { ErrorLevel, ErrorNotification } from "store/errors/types";
import { clearRemoteParticipants } from "store/remote-participants/slice";
import { setRoom } from "store/room/slice";
import { AppDispatch } from "store/store";
import styles from "./ErrorAlert.module.css";

interface ErrorAlertProps {
  /** The notification. */
  error?: ErrorNotification;
  /** An handler attached to the dismiss button on the alert. If not provided,
   * the button will not be displayed.
   */
  dismiss?: (id: number) => void;
}

/** An error alert. */
export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  error,
  dismiss,
}: ErrorAlertProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const getAlertStyle = (level?: ErrorLevel) => {
    switch(level) {
      case ErrorLevel.Info:
        return "alert-info";
      case ErrorLevel.Warning:
        return "alert-warning";
      case ErrorLevel.Danger:
      default:
        return "alert-danger";
    }
  }
  return (
    <>
      {error && (
        <div className="row justify-content-center">
          <div
            className={`${styles["alert-container"]} alert ${getAlertStyle(error.level)} ${
              error.showDismiss ? "alert-dismissible fade show" : ""
            }`}
            role="alert"
          >
            {error.name}: {error.message}
            {error.showButton && (
              <button
                className="btn btn-outline-info mt-2"
                onClick={() => {
                  dispatch(clearRemoteParticipants());
                  dispatch(setRoom(undefined));
                  dispatch(removeErrorNotification());
                }}
              >
                Reconnect
              </button>
            )}
            {(error.showDismiss && dismiss) && (
              <button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={() => dismiss(error.id)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
